import angular from 'angular';
import quantityDisplay from './quantityDisplay';

export default angular
  .module('components.quantityDisplay', [])
  .component('quantityDisplay', quantityDisplay).name;
